import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalResultadosConversionService {
  private mostrarModalSubject = new BehaviorSubject<boolean>(false);
  private datosSubject = new BehaviorSubject<any[]>([]);

  public mostrarModal$ = this.mostrarModalSubject.asObservable();
  public datos$ = this.datosSubject.asObservable();

  constructor() { }

  /**
   * Muestra el modal con los datos de conversión
   */
  mostrarModal(datos: any[]): void {
    this.datosSubject.next(datos);
    this.mostrarModalSubject.next(true);
  }

  /**
   * Oculta el modal
   */
  ocultarModal(): void {
    this.mostrarModalSubject.next(false);
    this.datosSubject.next([]);
  }
}



